import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class AutoReferralModel extends BaseModel {
  static urlPath = "auto/referrals";

  @attr("number") pk;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("json") autoProvider;
  @attr("json") case;
  @attr("string") notes;
  @attr("string") emailSentTimestamp;
  @attr("string") emailSentTo;
}
